import React from 'react';
import { Table, Input, Button, Icon, Alert, Form, Select } from 'antd';
import '../App.css';
import config from '.././config.json';
import $ from 'jquery';
const FormItem = Form.Item;
const Option = Select.Option;
const day = [];
for (let i = 1; i < 32; i++) {
    day.push(<Option key={String("0" + i).slice(-2)}>{String("0" + i).slice(-2)}</Option>);
}

var year = new Date().getFullYear();
const yearList = [];
for (let i = year; i > year - 100; i--) {
    yearList.push(<Option key={String(i)}>{String(i)}</Option>);
}

class DatePickerDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.month;
        this.date;
        this.year;
    }
    state = {
        data: [],
        value: ''
    }

    componentWillMount() {
        if (typeof this.props.sendUserData !== "undefined" && this.props.sendUserData !== '') {

            var date = new Date(this.props.sendUserData);

            var month = date.getMonth() + 1;
            this.month = String("0" + month).slice(-2);
            this.date = String("0" + date.getDate()).slice(-2);
            this.year = date.getFullYear().toString();
        }
    }

    handleChangeMonth = (value) => {

        this.month = value;
        this.sendData();
    }

    handleChangeDate = (value) => {

        this.date = value;
        this.sendData();
    }

    handleChangeYear = (value) => {

        this.year = value;
        this.sendData();
    }

    onFocusM = () => {
        document.getElementById("month").click();
    }

    onFocusD = () => {
        document.getElementById("date").click();
    }

    onFocusY = () => {
        document.getElementById("year").click();
    }

    displayYear() {
        if (this.state.isUserNew) {
            return 0;
        }
        else {
            return this.year;
        }
    }
    render() {

        const isUserNew = this.props.isUserNew;
        console.log("props is user new: " + isUserNew);
        const { getFieldDecorator } = this.props.form;
        return (
            <div>

                {getFieldDecorator('month', {
                    initialValue: this.month,
                })(
                    <Select
                        showSearch
                        style={{ width: 120 }}
                        placeholder="Select a person"
                        optionFilterProp="children"
                        onChange={this.handleChangeMonth} placeholder="Month"
                        onFocus={this.onFocusM}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        <Option value='01'>January</Option>
                        <Option value='02'>February</Option>
                        <Option value='03'>March</Option>
                        <Option value='04'>April</Option>
                        <Option value='05'>May</Option>
                        <Option value='06'>June</Option>
                        <Option value='07'>July</Option>
                        <Option value='08'>August</Option>
                        <Option value='09'>September</Option>
                        <Option value='10'>October</Option>
                        <Option value='11'>November</Option>
                        <Option value='12'>December</Option>
                    </Select>)}
                {getFieldDecorator('date', {
                    initialValue: this.date,
                })(
                    <Select showSearch style={{ width: 100 }} onChange={this.handleChangeDate} placeholder="Date" onFocus={this.onFocusD}>
                        {day}
                    </Select>)}

                {/*Only show the year if the user is new*/}
                {this.displayYear()}

            </div>
        );
    }

    displayYear() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div style={{ display: 'inline-block', positions: 'relative', height: '100%', width: '25%', margin: 0 }}>
                {getFieldDecorator('year', { initialValue: this.year, })(
                    <Select showSearch style={{ width: 120 }}
                        onChange={this.handleChangeYear}
                        placeholder="Year"
                        onFocus={this.onFocusY}>
                        {yearList}
                    </Select>)}
            </div>
        );
    }

    sendData() {
        if (this.date != undefined && this.year != undefined && this.month != undefined) {
            var dob = this.month + "/" + this.date + "/" + this.year;
            if (typeof this.props.getDOB === "function") {
                this.props.getDOB(dob);
            }

            else if (typeof this.props.getDOBNew === "function") {
                this.props.getDOBNew(dob);
            }

        }
    }
}
const WrappedDemo = Form.create()(DatePickerDropdown);
export default WrappedDemo;


// WEBPACK FOOTER //
// ./src/Registration/DatePickerDropdown.js